export default function () {
    let value = undefined;
    return {
        get: () => {
            return value;
        },
        set: (newValue) => {
            value = newValue;
        }
    };
}
